"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.getPrimaryAndRecommendedRevenueType = exports.calculateSalesTaxRevenueV2WithAdjustment = exports.salesTaxCanUpdate_Throwable = exports.salesTaxCanUpdate = exports.salesTaxCanStartFiling = exports.salesTaxCanAcceptRevenue = exports.calculateSalesTaxRevenueV2 = exports.isTaxFilingEligibleForMonth = void 0;
var hyper_utils_1 = require("hyper-utils");
var constants_1 = require("../constants");
var enums_1 = require("../enums");
var services_1 = require("../services");
function isTaxFilingEligibleForMonth(monthYYYYMM, objSubClient) {
    var month = monthYYYYMM.split("-")[1];
    if (!month)
        return false;
    if ((objSubClient === null || objSubClient === void 0 ? void 0 : objSubClient.FrequencyOfFiling) === enums_1.FREQUENCY_OF_FILING.MONTHLY) {
        return true;
    }
    else if ((objSubClient === null || objSubClient === void 0 ? void 0 : objSubClient.FrequencyOfFiling) === enums_1.FREQUENCY_OF_FILING.QUARTERLY) {
        return month === "12" || month === "03" || month === "06" || month === "09";
    }
    else if ((objSubClient === null || objSubClient === void 0 ? void 0 : objSubClient.FrequencyOfFiling) === enums_1.FREQUENCY_OF_FILING.SEMI_ANNUALLY) {
        return month === "12" || month === "06";
    }
    else if ((objSubClient === null || objSubClient === void 0 ? void 0 : objSubClient.FrequencyOfFiling) === enums_1.FREQUENCY_OF_FILING.ANNUALLY) {
        return month === "12";
    }
}
exports.isTaxFilingEligibleForMonth = isTaxFilingEligibleForMonth;
/**
 * This method will calculate  Revenue fields defined in `ISalesRevenueObject`
 * @param data Tax filing record.
 */
function calculateSalesTaxRevenueV2(data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    if (!(data === null || data === void 0 ? void 0 : data.Revenue))
        return null;
    var objOutput = {};
    var objInput = data.Revenue;
    if (data.Revenue instanceof Map) {
        objInput = Object.fromEntries(data.Revenue);
    }
    /** Convert Revenue values to numeric type */
    for (var key in objInput) {
        if (typeof objInput[key] !== "number")
            objInput[key] = Number(objInput[key]) || 0;
    }
    /** Verify and set percentages
     * After this step all percentage will have a value. At least `0`.
     * `{revenueKey}_PERCENTAGE` will have appropriate value. so no Need to perform if condition.
     */
    objOutput.PERCENTAGE = data.Tax.DefaultSalesTaxPercentage || 0;
    objOutput.SURTAX_PERCENTAGE = data.Tax.SurtaxPercentage || 0;
    objOutput.TAXABLE_PURCHASE_PERCENTAGE =
        ((_b = (_a = data.Tax) === null || _a === void 0 ? void 0 : _a.IncomeTypeMapping) === null || _b === void 0 ? void 0 : _b.TAXABLE_PURCHASE) || objOutput.PERCENTAGE;
    objOutput.SALES_AND_SERVICE_PERCENTAGE =
        ((_d = (_c = data.Tax) === null || _c === void 0 ? void 0 : _c.IncomeTypeMapping) === null || _d === void 0 ? void 0 : _d.SALES_AND_SERVICE) || objOutput.PERCENTAGE;
    objOutput.COMMERCIAL_RENTAL_PERCENTAGE =
        ((_f = (_e = data.Tax) === null || _e === void 0 ? void 0 : _e.IncomeTypeMapping) === null || _f === void 0 ? void 0 : _f.COMMERCIAL_RENTAL) || objOutput.PERCENTAGE;
    objOutput.TRANSIENT_RENTALS_PERCENTAGE =
        ((_h = (_g = data.Tax) === null || _g === void 0 ? void 0 : _g.IncomeTypeMapping) === null || _h === void 0 ? void 0 : _h.TRANSIENT_RENTALS) || objOutput.PERCENTAGE;
    objOutput.FOOD_AND_BEVERAGE_PERCENTAGE =
        ((_k = (_j = data.Tax) === null || _j === void 0 ? void 0 : _j.IncomeTypeMapping) === null || _k === void 0 ? void 0 : _k.FOOD_AND_BEVERAGE) || objOutput.PERCENTAGE;
    /** Create Amount for Taxable purchase */
    objOutput.TAXABLE_PURCHASE = objInput.TAXABLE_PURCHASE || 0;
    objOutput.TAXABLE_PURCHASE_SURTAX_AMOUNT = hyper_utils_1.CommonUtils.toFixedNumber(hyper_utils_1.CommonUtils.getPercentage(objOutput.TAXABLE_PURCHASE, objOutput.SURTAX_PERCENTAGE), 2);
    objOutput.TAXABLE_PURCHASE_SALES_TAX_AMOUNT = hyper_utils_1.CommonUtils.toFixedNumber(hyper_utils_1.CommonUtils.getPercentage(objOutput.TAXABLE_PURCHASE, objOutput.TAXABLE_PURCHASE_PERCENTAGE), 2);
    objOutput.TAXABLE_PURCHASE_TAX_DUE = hyper_utils_1.CommonUtils.toFixedNumber(hyper_utils_1.CommonUtils.getPercentage(objOutput.TAXABLE_PURCHASE, objOutput.TAXABLE_PURCHASE_PERCENTAGE + objOutput.SURTAX_PERCENTAGE), 2);
    updateTaxCalculation(objInput, objOutput, "SALES_AND_SERVICE");
    updateTaxCalculation(objInput, objOutput, "COMMERCIAL_RENTAL");
    updateTaxCalculation(objInput, objOutput, "TRANSIENT_RENTALS");
    updateTaxCalculation(objInput, objOutput, "FOOD_AND_BEVERAGE");
    calculateTotals(objOutput);
    var RevenueType = getPrimaryAndRecommendedRevenueType(__assign({ objRevenue: objOutput }, data));
    if (((_m = (_l = data === null || data === void 0 ? void 0 : data.SubClient) === null || _l === void 0 ? void 0 : _l.ApplyAvoidAudit) === null || _m === void 0 ? void 0 : _m.IsActive) &&
        objOutput.TOTAL_TAX_COLLECTED < objOutput.IDEAL_TAX_DUE) {
        var ApplyAvoidAudit = (_o = data === null || data === void 0 ? void 0 : data.SubClient) === null || _o === void 0 ? void 0 : _o.ApplyAvoidAudit;
        var DueToAdjust = 0;
        if (ApplyAvoidAudit.AdjustmentType === "PERCENTAGE") {
            DueToAdjust = hyper_utils_1.CommonUtils.getPercentage(objOutput["".concat(RevenueType.RecommendedRevenueType, "_NET_REVENUE")], ApplyAvoidAudit.AdjustmentValue || 0);
            if (DueToAdjust) {
                objOutput["".concat(RevenueType.RecommendedRevenueType, "_PERCENTAGE")] +=
                    ApplyAvoidAudit.AdjustmentValue;
                objOutput["".concat(RevenueType.RecommendedRevenueType, "_SALES_TAX_AMOUNT")] +=
                    DueToAdjust;
            }
        }
        else if (ApplyAvoidAudit.AdjustmentType === "AMOUNT") {
            DueToAdjust = ApplyAvoidAudit.AdjustmentValue || 0;
            if (DueToAdjust)
                objOutput["".concat(RevenueType.RecommendedRevenueType, "_SALES_TAX_AMOUNT")] +=
                    DueToAdjust;
        }
        if (DueToAdjust > 0) {
            objOutput["".concat(RevenueType.RecommendedRevenueType, "_TAX_DUE")] += DueToAdjust;
            objOutput["".concat(RevenueType.RecommendedRevenueType, "_AVOID_AUDIT_ADJUSTMENT")] = DueToAdjust;
            objOutput.AVOID_AUDIT_ADJUSTMENT = DueToAdjust;
        }
        calculateTotals(objOutput);
    }
    /** Tax collected calculation
     * if `TOTAL_TAX_COLLECTED` is grater then `TOTAL_TAX_DUE` then TOTAL_TAX_DUE = Total Tax collected
     */
    objOutput.TOTAL_TAX_COLLECTED = objInput.TOTAL_TAX_COLLECTED || 0;
    /** We need to adjust extra Tax collected into Primary Revenue Type as Tax collected.  */
    objOutput.EXTRA_TAX_COLLECTED = 0;
    if (objOutput.TOTAL_TAX_COLLECTED > objOutput.IDEAL_TAX_DUE) {
        objOutput.EXTRA_TAX_COLLECTED =
            objOutput.TOTAL_TAX_COLLECTED - objOutput.IDEAL_TAX_DUE;
        objOutput.TOTAL_TAX_DUE = objOutput.TOTAL_TAX_COLLECTED;
        objOutput["".concat(RevenueType.RecommendedRevenueType, "_EXTRA_TAX_COLLECTED")] =
            objOutput.EXTRA_TAX_COLLECTED;
        /** Add Extra tax collected into tax due.  */
        objOutput["".concat(RevenueType.RecommendedRevenueType, "_TAX_DUE")] +=
            objOutput.EXTRA_TAX_COLLECTED;
    }
    /** Calculate `7. Net Tax Due` by deducting lawful deduction */
    objOutput.LAWFUL_DEDUCTIONS = objInput.LAWFUL_DEDUCTIONS || 0;
    objOutput.TAX_DUE_AFTER_LAWFUL_DEDUCTIONS = hyper_utils_1.CommonUtils.toFixedNumber(objOutput.TOTAL_TAX_DUE - objOutput.LAWFUL_DEDUCTIONS, 2);
    /**
     * calculate `10. Amount Due` by
     * 8. Less Est Tax Pd/DOR Cr Memo
     * 9. Plus Est. Tax Due Current Month
     */
    objOutput.ESTIMATE_TAX_DOR_MEMO = objInput.ESTIMATE_TAX_DOR_MEMO || 0;
    objOutput.ESTIMATE_TAX_DUE_CURRENT_MONTH =
        objInput.ESTIMATE_TAX_DUE_CURRENT_MONTH || 0;
    objOutput.TAX_DUE_AFTER_ESTIMATE_TAX = hyper_utils_1.CommonUtils.toFixedNumber(objOutput.TAX_DUE_AFTER_LAWFUL_DEDUCTIONS -
        objOutput.ESTIMATE_TAX_DOR_MEMO +
        objOutput.ESTIMATE_TAX_DUE_CURRENT_MONTH, 2);
    objOutput.PENALTY = objInput.PENALTY || 0;
    objOutput.INTEREST = objInput.INTEREST || 0;
    /** Calculate Amount to be paid
     * 14. Amount Due With Return
     */
    objOutput.AMOUNT_TO_BE_PAID =
        objOutput.TAX_DUE_AFTER_ESTIMATE_TAX +
            objOutput.PENALTY +
            objOutput.INTEREST;
    /** calculate Collection allowance if there is no penalty or interest.
     *  And client is not donating it.  */
    if (((_p = data.SubClient) === null || _p === void 0 ? void 0 : _p.DonateAllowance) ||
        objOutput.PENALTY ||
        objOutput.INTEREST ||
        data.IsLateFiling // IN case of late filing no collection allowance
    ) {
        objOutput.COLLECTION_ALLOWANCE = 0;
    }
    else {
        objOutput.COLLECTION_ALLOWANCE =
            services_1.CommonLibUtils.roundSpecialCollectionAllowanceForState(hyper_utils_1.CommonUtils.getPercentage(objOutput.AMOUNT_TO_BE_PAID, 2.5), 2);
        /** Maximum allowance is 30 */
        if (objOutput.COLLECTION_ALLOWANCE > 30)
            objOutput.COLLECTION_ALLOWANCE = 30;
        objOutput.AMOUNT_TO_BE_PAID = hyper_utils_1.CommonUtils.toFixedNumber(objOutput.AMOUNT_TO_BE_PAID - objOutput.COLLECTION_ALLOWANCE, 2);
    }
    /** Replicate 15(a,b,c) */
    objOutput.ROW_15A_EXEMPT_AMOUNT_OF_ITEMS_OVER =
        objInput.ROW_15A_EXEMPT_AMOUNT_OF_ITEMS_OVER;
    objOutput.ROW_15B_OTHER_TAXABLE_AMOUNTS_NOT_SUBJECT_TO_SURTAX =
        objInput.ROW_15B_OTHER_TAXABLE_AMOUNTS_NOT_SUBJECT_TO_SURTAX;
    objOutput.ROW_15C_AMOUNTS_SUBJECT_TO_SURTAX =
        objInput.ROW_15C_AMOUNTS_SUBJECT_TO_SURTAX;
    /** calculate 15(d) total surtax */
    objOutput.ROW_15D_TOTAL_AMOUNT_OF_DISCRETIONARY_SALES_SURTAX =
        hyper_utils_1.CommonUtils.toFixedNumber(objOutput.TAXABLE_PURCHASE_SURTAX_AMOUNT +
            objOutput.SALES_AND_SERVICE_SURTAX_AMOUNT +
            objOutput.COMMERCIAL_RENTAL_SURTAX_AMOUNT +
            objOutput.TRANSIENT_RENTALS_SURTAX_AMOUNT +
            objOutput.FOOD_AND_BEVERAGE_SURTAX_AMOUNT +
            objOutput.EXTRA_TAX_COLLECTED, 2);
    return objOutput;
}
exports.calculateSalesTaxRevenueV2 = calculateSalesTaxRevenueV2;
/** This method will eliminate the repetitive code block for calculating
 * sales tax portion surtax etc.
 * - This method will mutate the `objOutput`
 */
function updateTaxCalculation(objInput, objOutput, revenueKey) {
    objOutput["".concat(revenueKey, "_EXTRA_TAX_COLLECTED")] = 0;
    objOutput["".concat(revenueKey, "_AVOID_AUDIT_ADJUSTMENT")] = 0;
    objOutput["".concat(revenueKey, "_GROSS_REVENUE")] =
        objInput["".concat(revenueKey, "_GROSS_REVENUE")] || 0;
    objOutput["".concat(revenueKey, "_EXEMPT_REVENUE")] =
        objInput["".concat(revenueKey, "_EXEMPT_REVENUE")] || 0;
    objOutput["".concat(revenueKey, "_NET_REVENUE")] =
        objOutput["".concat(revenueKey, "_GROSS_REVENUE")] -
            objOutput["".concat(revenueKey, "_EXEMPT_REVENUE")];
    objOutput["".concat(revenueKey, "_SURTAX_AMOUNT")] = hyper_utils_1.CommonUtils.toFixedNumber(hyper_utils_1.CommonUtils.getPercentage(objOutput["".concat(revenueKey, "_NET_REVENUE")], objOutput.SURTAX_PERCENTAGE), 2);
    objOutput["".concat(revenueKey, "_SALES_TAX_AMOUNT")] = hyper_utils_1.CommonUtils.toFixedNumber(hyper_utils_1.CommonUtils.getPercentage(objOutput["".concat(revenueKey, "_NET_REVENUE")], objOutput["".concat(revenueKey, "_PERCENTAGE")]), 2);
    objOutput["".concat(revenueKey, "_TAX_DUE")] = hyper_utils_1.CommonUtils.toFixedNumber(hyper_utils_1.CommonUtils.getPercentage(objOutput["".concat(revenueKey, "_NET_REVENUE")], objOutput["".concat(revenueKey, "_PERCENTAGE")] + objOutput.SURTAX_PERCENTAGE), 2);
}
function calculateTotals(objOutput) {
    /** calculate total and other calculations */
    objOutput.TOTAL_GROSS_REVENUE =
        objOutput.TAXABLE_PURCHASE +
            objOutput.SALES_AND_SERVICE_GROSS_REVENUE +
            objOutput.COMMERCIAL_RENTAL_GROSS_REVENUE +
            objOutput.TRANSIENT_RENTALS_GROSS_REVENUE +
            objOutput.FOOD_AND_BEVERAGE_GROSS_REVENUE;
    objOutput.TOTAL_EXEMPT_REVENUE =
        objOutput.SALES_AND_SERVICE_EXEMPT_REVENUE +
            objOutput.COMMERCIAL_RENTAL_EXEMPT_REVENUE +
            objOutput.TRANSIENT_RENTALS_EXEMPT_REVENUE +
            objOutput.FOOD_AND_BEVERAGE_EXEMPT_REVENUE;
    objOutput.TOTAL_NET_REVENUE =
        objOutput.TAXABLE_PURCHASE +
            objOutput.SALES_AND_SERVICE_NET_REVENUE +
            objOutput.COMMERCIAL_RENTAL_NET_REVENUE +
            objOutput.TRANSIENT_RENTALS_NET_REVENUE +
            objOutput.FOOD_AND_BEVERAGE_NET_REVENUE;
    /** Calculate total tax due.
     * 5. Total Amount of Tax Due
     */
    objOutput.TOTAL_TAX_DUE = hyper_utils_1.CommonUtils.toFixedNumber(objOutput.TAXABLE_PURCHASE_TAX_DUE +
        objOutput.SALES_AND_SERVICE_TAX_DUE +
        objOutput.COMMERCIAL_RENTAL_TAX_DUE +
        objOutput.TRANSIENT_RENTALS_TAX_DUE +
        objOutput.FOOD_AND_BEVERAGE_TAX_DUE, 2);
    objOutput.IDEAL_TAX_DUE = objOutput.TOTAL_TAX_DUE;
}
function salesTaxCanAcceptRevenue(objFiling) {
    var StatusInAccept = constants_1.taxFilingStatusGroup.ACCEPT_REVENUE.includes(objFiling.Status);
    return StatusInAccept;
}
exports.salesTaxCanAcceptRevenue = salesTaxCanAcceptRevenue;
function salesTaxCanStartFiling(objFiling) {
    var StatusInAccept = constants_1.taxFilingStatusGroup.FILING_BOT_CAN_START.includes(objFiling.Status);
    return StatusInAccept;
}
exports.salesTaxCanStartFiling = salesTaxCanStartFiling;
function salesTaxCanUpdate(objFiling) {
    var StatusInAccept = !constants_1.taxFilingStatusGroup.DISALLOW_UPDATE.includes(objFiling.Status);
    return StatusInAccept;
}
exports.salesTaxCanUpdate = salesTaxCanUpdate;
function salesTaxCanUpdate_Throwable(objFiling) {
    var can = salesTaxCanUpdate(objFiling);
    if (!can)
        throw new Error("Tax filing can't be updated because it's one of following status. ".concat(constants_1.taxFilingStatusGroup.DISALLOW_UPDATE));
}
exports.salesTaxCanUpdate_Throwable = salesTaxCanUpdate_Throwable;
function calculateSalesTaxRevenueV2WithAdjustment(data) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var objRevenue = calculateSalesTaxRevenueV2(data);
    var objAdjustment = {};
    if (data.AdjustExemptToMatchTaxCollected &&
        objRevenue.TOTAL_TAX_COLLECTED &&
        objRevenue.IDEAL_TAX_DUE) {
        var diff = objRevenue.IDEAL_TAX_DUE - objRevenue.TOTAL_TAX_COLLECTED;
        // If Tax collected is less, Than only adjust exempt
        if (diff <= 50 && diff > 0) {
            var ExpectedTaxableAmount = (objRevenue.TOTAL_TAX_COLLECTED /
                (objRevenue.SALES_AND_SERVICE_PERCENTAGE +
                    objRevenue.SURTAX_PERCENTAGE)) *
                100;
            var TaxableAmountDiff = Math.abs(objRevenue.SALES_AND_SERVICE_NET_REVENUE -
                ExpectedTaxableAmount);
            objRevenue.SALES_AND_SERVICE_EXEMPT_REVENUE =
                objRevenue.SALES_AND_SERVICE_EXEMPT_REVENUE + TaxableAmountDiff;
            var adjustmentMessage = "\n Exempt Sales is adjusted (+".concat(services_1.CommonLibUtils.prettyPrice(TaxableAmountDiff), ") to match Total Tax Collected.");
            objAdjustment["SALES_AND_SERVICE_EXEMPT_REVENUE"] = {
                Key: "SALES_AND_SERVICE_EXEMPT_REVENUE",
                Message: adjustmentMessage,
                BackgroundColor: "yellow"
            };
            objRevenue = calculateSalesTaxRevenueV2(data);
        }
    }
    var RevenueType = getPrimaryAndRecommendedRevenueType(__assign(__assign({}, data), { objRevenue: objRevenue }));
    if (objRevenue.AVOID_AUDIT_ADJUSTMENT) {
        objAdjustment["".concat(RevenueType.RecommendedRevenueType, "_TAX_DUE")] = {
            Key: "".concat(RevenueType.RecommendedRevenueType, "_TAX_DUE"),
            Message: "Avoid Audit: Adjusted by ".concat(services_1.CommonLibUtils.prettyPrice(objRevenue["".concat(RevenueType.RecommendedRevenueType, "_AVOID_AUDIT_ADJUSTMENT")])),
            BackgroundColor: "lightblue"
        };
        if (((_b = (_a = data.SubClient) === null || _a === void 0 ? void 0 : _a.ApplyAvoidAudit) === null || _b === void 0 ? void 0 : _b.AdjustmentType) === "AMOUNT") {
            objAdjustment["".concat(RevenueType.RecommendedRevenueType, "_SALES_TAX_AMOUNT")] =
                {
                    Key: "".concat(RevenueType.RecommendedRevenueType, "_TAX_DUE"),
                    Message: "Avoid Audit: Amount adjusted by ".concat((_d = (_c = data.SubClient) === null || _c === void 0 ? void 0 : _c.ApplyAvoidAudit) === null || _d === void 0 ? void 0 : _d.AdjustmentValue),
                    BackgroundColor: "lightblue"
                };
        }
        else if (((_f = (_e = data.SubClient) === null || _e === void 0 ? void 0 : _e.ApplyAvoidAudit) === null || _f === void 0 ? void 0 : _f.AdjustmentType) === "PERCENTAGE") {
            objAdjustment["".concat(RevenueType.RecommendedRevenueType, "_PERCENTAGE")] = {
                Key: "".concat(RevenueType.RecommendedRevenueType, "_TAX_DUE"),
                Message: "Avoid Audit: Percentage adjusted by ".concat((_h = (_g = data.SubClient) === null || _g === void 0 ? void 0 : _g.ApplyAvoidAudit) === null || _h === void 0 ? void 0 : _h.AdjustmentValue),
                BackgroundColor: "lightblue"
            };
            objAdjustment["".concat(RevenueType.RecommendedRevenueType, "_SALES_TAX_AMOUNT")] =
                {
                    Key: "".concat(RevenueType.RecommendedRevenueType, "_TAX_DUE"),
                    Message: "Avoid Audit: Amount adjusted by ".concat(services_1.CommonLibUtils.prettyPrice(objRevenue["".concat(RevenueType.RecommendedRevenueType, "_AVOID_AUDIT_ADJUSTMENT")])),
                    BackgroundColor: "lightblue"
                };
        }
    }
    if (objRevenue.TOTAL_TAX_COLLECTED &&
        data.IsRevenuePennyAdjustmentEnabled &&
        data.RevenuePennyAdjustmentThreshold) {
        var diff = hyper_utils_1.CommonUtils.toFixedNumber(objRevenue.IDEAL_TAX_DUE - objRevenue.TOTAL_TAX_COLLECTED, 2);
        if (Math.abs(diff) > 0 &&
            Math.abs(diff) <= Number(data.RevenuePennyAdjustmentThreshold)) {
            var percentage = objRevenue["".concat(RevenueType.RecommendedRevenueType, "_PERCENTAGE")] +
                objRevenue.SURTAX_PERCENTAGE;
            var RevenueDiff = -((diff / percentage) * 100);
            objRevenue["".concat(RevenueType.RecommendedRevenueType, "_GROSS_REVENUE")] =
                hyper_utils_1.CommonUtils.toFixedNumber(objRevenue["".concat(RevenueType.RecommendedRevenueType, "_GROSS_REVENUE")] +
                    RevenueDiff, 2);
            objAdjustment["".concat(RevenueType.RecommendedRevenueType, "_GROSS_REVENUE")] = {
                Message: "".concat(services_1.CommonLibUtils.prettyPrice(RevenueDiff), " Adjusted"),
                Key: "".concat(RevenueType.RecommendedRevenueType, "_GROSS_REVENUE"),
                BackgroundColor: "yellow",
                Context: {
                    PennyAdjustmentFor: diff
                }
            };
            objRevenue = calculateSalesTaxRevenueV2(__assign(__assign({}, data), { Revenue: objRevenue }));
        }
    }
    return {
        objRevenue: objRevenue,
        objAdjustment: objAdjustment
    };
}
exports.calculateSalesTaxRevenueV2WithAdjustment = calculateSalesTaxRevenueV2WithAdjustment;
function getPrimaryAndRecommendedRevenueType(data) {
    var _a, _b, _c;
    var PrimaryRevenueType = ((_c = (_a = data.objBusinessTypeMapping) === null || _a === void 0 ? void 0 : _a[((_b = data === null || data === void 0 ? void 0 : data.SubClient) === null || _b === void 0 ? void 0 : _b.BusinessType) || ""]) === null || _c === void 0 ? void 0 : _c.PrimaryRevenueType) || "SALES_AND_SERVICE";
    var RecommendedRevenueType = PrimaryRevenueType;
    if (!data.objRevenue["".concat(RecommendedRevenueType, "_TAX_DUE")]) {
        for (var _i = 0, _d = [
            "SALES_AND_SERVICE",
            "COMMERCIAL_RENTAL",
            "TRANSIENT_RENTALS",
            "FOOD_AND_BEVERAGE",
        ]; _i < _d.length; _i++) {
            var revenueType = _d[_i];
            if (data.objRevenue["".concat(revenueType, "_TAX_DUE")]) {
                RecommendedRevenueType = revenueType;
            }
        }
    }
    return {
        PrimaryRevenueType: PrimaryRevenueType,
        RecommendedRevenueType: RecommendedRevenueType
    };
}
exports.getPrimaryAndRecommendedRevenueType = getPrimaryAndRecommendedRevenueType;
//# sourceMappingURL=taxFilingUtils.js.map